import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextHelper from '../../../../../core/helpers/TextHelper';
import Modal from '../../../procedures/components/Modal/Modal';
import iconCancel from '../../../../../assets/illustrations/cancel-procedure.svg';
import iconWarning from '../../../../../assets/illustrations/warning.svg';
import Description from '../../../events/modules/eventDetail/components/Description';
import InPersonEventBox from '../../../events/modules/eventDetail/components/InPersonEventBox';
import RemoteEventBox from '../../../events/modules/eventDetail/components/RemoteEventBox';
import {
  ContainerFake,
  EventDetailContainer,
  Title
} from '../../../events/modules/eventDetail/components/styles';
import ContentModalTwoButtons from '../../../procedures/components/ContentModalTwoButtons';
import ContentModalOneButton from '../../../procedures/components/ContentModalOneButton';
import routes from '../../../../components/Routes/routingMap';
import Spinner from '../../../../components/Spinner';
import Processing from '@/presentation/components/Processing';
import EventTags from '../../../../components/EventTags';
import { getWaitingListStatus } from '@/presentation/modules/events/components/card/CardButtonEvent';
import WaitingListBoxes from '@/presentation/components/WaitingListBoxes';
import RenderButton from '../../../../components/RenderButton';
import ModuleContainer from '@/presentation/components/Container';
import Back from '@/presentation/reusables/Button/Back';
import ReusableDate from '@/presentation/reusables/Date';
import PopPupRestriction from '@/presentation/reusables/PopRestriction';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import WaitingListModals from '../../../shared/WaitingListModals';

const ReinforcementsDetailView = (props: any) => {
  const {
    goBackButton,
    event,
    handleSubscribe,
    showRegisterModal,
    setShowRegisterModal,
    showCancelModal,
    setShowCancelModal,
    onCancelSubscription,
    showWarningModal,
    setShowWarningModal,
    showVacanciesModal,
    setShowVacanciesModal,
    isLoading,
    isProcessing,
    showAccountNotRegistered,
    setShowAccountNotRegistered,
    showAccountNotActive,
    setShowAccountNotActive,
    restriction,
    setRestriction,
    onRegisterWaitingList,
    openWarningModal,
    openVacanciesModal,
    isRegisteredWaitingList,
    clearRegisterWaitingList,
    clearRegisterWaitingListWhenError,
    showWarningWaitingListModal,
    errorWarningWaitingListMessage,
    onUnregisterWaitingList
  } = props;

  const [
    showConfirmUnsuscribeWaitingList,
    setShowConfirmUnsuscribeWaitingList
  ] = useState(false);
  const history = useHistory();

  const {
    modality,
    isToday,
    isFeatured,
    description,
    classroom,
    flat,
    campus,
    address,
    isSubscribed,
    linkMeet,
    isRescheduled
  } = event || {};

  useEffect(() => {
    setShowWarningModal(openWarningModal);
  }, [openWarningModal]);

  useEffect(() => {
    setShowVacanciesModal(openVacanciesModal);
  }, [openVacanciesModal]);

  const { name, color } = getWaitingListStatus(event?.statusWaitingList);

  return (
    <ContainerFake>
      <ModuleContainer containerType="subsection">
        <EventDetailContainer>
          <div className="eventDetailButtom">
            <Back
              onClick={goBackButton}
              dataTestid="cmp-buttom-back-refactor"
            />
          </div>
        </EventDetailContainer>
        {isLoading && <Spinner />}

        {!isLoading && event && (
          <EventDetailContainer>
            <div className="eventDetailContainer">
              <div className="tags">
                <EventTags
                  isToday={isToday}
                  isFeatured={isFeatured}
                  isRescheduled={isRescheduled}
                  name={name}
                  color={color}
                  isSubscribed={isSubscribed}
                />
              </div>
              <Title data-testid="cmp-eventReforcement-title">
                {TextHelper.capitalize(event.name, true)}
              </Title>
              <ReusableDate
                size="large"
                endDate={event?.date}
                fontSize="14px"
                gap="8px"
                startDate={event?.date}
                style={{ marginBottom: '6px' }}
                schedule={[
                  {
                    startTime: event.hourStart,
                    endTime: event.hourEnd,
                    idDay: 0
                  }
                ]}
                isOnly
              />
              <div className="fields">
                <div>
                  {/* {eventType.name === 'WORKSHOPS' ? 'Docente' : 'Ponente'}:{' '} */}
                  {`Tutor(a) ${TextHelper.capitalize(
                    event.nameTeacher.replace(',', ', ')
                  )}`}
                </div>
              </div>
              {event.vacancies > 0 && (
                <div className="fields">Vacantes: {event.vacancies}</div>
              )}
              {description ? (
                <Description descriptionDetails={description} />
              ) : (
                <div style={{ marginTop: '28px' }} />
              )}
              {modality?.code === 'P' && (
                <InPersonEventBox
                  classroom={classroom}
                  flat={flat}
                  campus={campus}
                  address={address}
                />
              )}
              {modality?.code === 'R' && isSubscribed && (
                <RemoteEventBox
                  urlButtonZoom={linkMeet}
                  isSubscribed={isSubscribed}
                />
              )}
              <WaitingListBoxes
                event={{
                  ...event,
                  waitingListDescription:
                    'Este taller o tutoría no tiene vacantes. Si se libera una, recibirás un correo y contarás con 24 horas para inscribirte. Podrás retirarte de la lista si necesitas.',
                  waitingListModalContent: (
                    <ul
                      style={{
                        marginLeft: 20,
                        marginTop: 16,
                        color: '#161D1F'
                      }}
                    >
                      <li style={{ listStyle: 'initial' }}>
                        Cuando un taller o tutoría se llena, puedes unirte a la
                        lista de espera.
                      </li>
                      <li style={{ listStyle: 'initial' }}>
                        Si un estudiante anula su inscripción, se libera una
                        vacante y notificaremos al siguiente en la lista.
                      </li>
                      <li style={{ listStyle: 'initial' }}>
                        Te avisaremos hasta un día antes del inicio.
                      </li>
                    </ul>
                  )
                }}
                onRegisterWaitingList={onRegisterWaitingList}
                onLeaveWaitingList={() =>
                  setShowConfirmUnsuscribeWaitingList(true)
                }
              />
              <div style={{ marginTop: 20 }}>
                <RenderButton
                  isSubscribed={isSubscribed}
                  onCancel={() => setShowCancelModal(true)}
                  onSubscribe={() => {
                    GoogleAnalytics.writeLog(
                      'portal-services-signUpReinforcement',
                      'services'
                    );
                    setShowRegisterModal(true);
                  }}
                  disableSubscribe={['HL', 'LE', 'IN'].includes(
                    event.statusWaitingList
                  )}
                />
              </div>
            </div>
          </EventDetailContainer>
        )}
        <Processing isOpen={isProcessing} />
        <Modal
          show={
            showRegisterModal &&
            !isProcessing &&
            !showWarningModal &&
            !showVacanciesModal &&
            !showAccountNotRegistered &&
            !showAccountNotActive
          }
          handleClose={() => setShowRegisterModal(false)}
        >
          <ContentModalTwoButtons
            img={null}
            title="¿Estás seguro de inscribirte?"
            subtitle="Confirma tu inscripción."
            showInfo={false}
            textButton1="Sí, inscribirme"
            onClickButton1={() => handleSubscribe(event.id)}
            textButton2="Cancelar"
            onClickButton2={() => setShowRegisterModal(false)}
          />
        </Modal>
        <Modal
          show={showCancelModal && !isProcessing}
          handleClose={() => setShowCancelModal(false)}
        >
          <ContentModalTwoButtons
            img={iconCancel}
            title="¿Deseas anular esta Inscripción?"
            subtitle="Al aceptar esta acción, recuerda que tendrás que volver a inscribirte."
            showInfo={false}
            textButton1="Sí, anular"
            onClickButton1={() => {
              setShowCancelModal(false);
              onCancelSubscription(event.id);
            }}
            textButton2="Cancelar"
            onClickButton2={() => setShowCancelModal(false)}
          />
        </Modal>
        <Modal
          show={showWarningModal && !isProcessing}
          handleClose={() => {
            setShowWarningModal(false);
            setShowRegisterModal(false);
          }}
        >
          <ContentModalOneButton
            img={iconWarning}
            title="Ocurrió un problema inesperado"
            subtitle="Por favor, vuelve a intentarlo."
            showInfo={false}
            textButton="Reintentar"
            style={{ textAlign: 'center' }}
            onClickButton={() => handleSubscribe(event.id)}
          />
        </Modal>
        <Modal
          show={showVacanciesModal && !isProcessing}
          handleClose={() => {
            setShowVacanciesModal(false);
            setShowRegisterModal(false);
          }}
        >
          <ContentModalOneButton
            title="Lo sentimos, se acabaron las vacantes"
            subtitle="Te invitamos a escoger otra opción que sea de tu preferencia"
            showInfo={false}
            textButton="Entendido"
            style={{ textAlign: 'center' }}
            onClickButton={() => {
              setShowVacanciesModal(false);
              history.push(routes.student.reinforcements.home);
            }}
          />
        </Modal>
        <Modal
          show={showAccountNotRegistered && !isProcessing}
          handleClose={() => {
            setShowAccountNotRegistered(false);
            setShowRegisterModal(false);
          }}
        >
          <ContentModalOneButton
            img={iconWarning}
            title="No tienes una cuenta de Zoom registrada"
            subtitle="Revisa tu correo institucional con la invitación de Zoom o consulta con SAE"
            showInfo={false}
            textButton="Entendido"
            style={{ textAlign: 'center' }}
            onClickButton={() => {
              setShowAccountNotRegistered(false);
              history.push(routes.student.reinforcements.home);
            }}
          />
        </Modal>

        <Modal
          show={showAccountNotActive && !isProcessing}
          handleClose={() => {
            setShowAccountNotActive(false);
            setShowRegisterModal(false);
          }}
        >
          <ContentModalOneButton
            img={iconWarning}
            title="No tienes una cuenta de Zoom activa"
            subtitle="Solicita la activación escribiéndonos por SAE"
            showInfo={false}
            textButton="Entendido"
            style={{ textAlign: 'center' }}
            onClickButton={() => {
              setShowAccountNotActive(false);
              history.push(routes.student.reinforcements.home);
            }}
          />
        </Modal>
        <Modal show={restriction} handleClose={() => setRestriction(false)}>
          <PopPupRestriction handleClick={() => setRestriction(false)} />
        </Modal>
      </ModuleContainer>
      {/* Waiting list details handled by WaitingListBoxes */}
      <WaitingListModals
        isRegisteredWaitingList={isRegisteredWaitingList}
        clearRegisterWaitingList={clearRegisterWaitingList}
        showWarningWaitingListModal={showWarningWaitingListModal}
        clearRegisterWaitingListWhenError={clearRegisterWaitingListWhenError}
        errorWarningWaitingListMessage={errorWarningWaitingListMessage}
        iconWarning={iconWarning}
        waitingListTitle="¡Estás en lista de espera para este taller o tutoría!"
      />
      <Modal
        show={
          !isProcessing &&
          !showWarningWaitingListModal &&
          showConfirmUnsuscribeWaitingList
        }
        handleClose={() => setShowConfirmUnsuscribeWaitingList(false)}
      >
        <ContentModalTwoButtons
          img={null}
          title="¿Estás seguro de salir de la lista de espera?"
          subtitle="Si sales, perderás tu lugar y tendrás que volver a unirte si aún está disponible el taller o tutoría. Confírmanos, por favor."
          showInfo={false}
          textButton1="Sí, salir"
          onClickButton1={onUnregisterWaitingList}
          textButton2="Cancelar"
          onClickButton2={() => setShowConfirmUnsuscribeWaitingList(false)}
          onRow
        />
      </Modal>
    </ContainerFake>
  );
};

export default ReinforcementsDetailView;
